module.exports = __webpack_public_path__ + "img/eat.73732a48.png";